<template>
  <div class="product-list">
    <div class="product_wrap">
      <div class="title">{{ title }}</div>
      <div class="describe" v-if="p">{{ p }}</div>
      <div class="product_list">
        <div
          class="product"
          v-for="(item, index) in productList"
          :key="index"
          @click="$router.push('/products/category/' + item.category)"
        >
          <div class="img-wrap">
            <img class="img" :src="item.showSrc" />
            <img class="hoverImg" :src="item.hoverImgSrc" />
          </div>
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
    <div class="show_more_wrap" v-if="p">
      <a-button type="primary" @click="$router.push('/products')">Show more></a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductList',
  data() {
    return {
      productList: [
        {
          title: "Men's Wear",
          showSrc: require('@/assets/homePage/men_wear.png'),
          imgSrc: require('@/assets/homePage/men_wear.png'),
          hoverImgSrc: require('@/assets/homePage/men_wear_hover.png'),
          category: 'men_s_clothing'
        },
        {
          title: "Women's Clothing",
          showSrc: require('@/assets/homePage/women_clothing.png'),
          imgSrc: require('@/assets/homePage/women_clothing.png'),
          hoverImgSrc: require('@/assets/homePage/women_clothing_hover.png'),
          category: 'women_s_clothing'
        },
        {
          title: 'Home Decoration',
          showSrc: require('@/assets/homePage/home_decoration.png'),
          imgSrc: require('@/assets/homePage/home_decoration.png'),
          hoverImgSrc: require('@/assets/homePage/home_decoration_hover.png'),
          category: 'bedding'
        },
        {
          title: 'Pillow',
          showSrc: require('@/assets/homePage/pillow.png'),
          imgSrc: require('@/assets/homePage/pillow.png'),
          hoverImgSrc: require('@/assets/homePage/pillow_hover.png'),
          category: 'decorative_pillows'
        },
        {
          title: 'Cup',
          showSrc: require('@/assets/homePage/cup.png'),
          imgSrc: require('@/assets/homePage/cup.png'),
          hoverImgSrc: require('@/assets/homePage/cup_hover.png'),
          category: 'cups'
        },
        {
          title: 'Holiday Supplies',
          showSrc: require('@/assets/homePage/holiday_supplies.png'),
          imgSrc: require('@/assets/homePage/holiday_supplies.png'),
          hoverImgSrc: require('@/assets/homePage/holiday_supplies_hover.png'),
          category: 'holiday_decor'
        },
        {
          title: 'Phone Case',
          showSrc: require('@/assets/homePage/phone_case.png'),
          imgSrc: require('@/assets/homePage/phone_case.png'),
          hoverImgSrc: require('@/assets/homePage/phone_case_hover.png'),
          category: 'phone_cases'
        },
        {
          title: 'Bag',
          showSrc: require('@/assets/homePage/bag.png'),
          imgSrc: require('@/assets/homePage/bag.png'),
          hoverImgSrc: require('@/assets/homePage/bag_hover.png'),
          category: 'lunch_bag'
        }
      ]
    }
  },
  props: ['title', 'p']
}
</script>

<style lang="less" scoped>
@keyframes show {
  0% {
    opacity: 0;
    display: inline;
  }
  100% {
    opacity: 1;
  }
}
@keyframes hidden {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}
.product-list {
  padding: 60px 260px;
  .product_wrap {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    .title {
      font-size: 40px;
      color: #333333;
      font-weight: 500;
    }
    .describe {
      font-size: 18px;
      color: #666666;
      font-weight: 400;
      width: 70%;
      text-align: center;
    }
    .product_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 60px;
      .product {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        width: 320px;
        height: 300px;
        background: #ffffff;
        border-radius: 24px;
        margin-top: 20px;
        .img-wrap {
          position: relative;
          height: 100%;
          width: 100%;
          img {
            width: 270px;
            height: 270px;
            transition: all 0.3s ease-in-out;
            animation: show;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .hoverImg {
          opacity: 0;
        }
        &:hover {
          cursor: pointer;
          .hoverImg {
            opacity: 1;
          }
          .img {
            opacity: 0;
          }
        }
      }
    }
    .view_all_button {
      width: 240px;
      height: 40px;
      background: #ffa200;
      margin-top: 20px;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 8px;
    }
  }
  .show_more_wrap {
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
}

@media screen and (max-width: 960px) {
  .product-list {
    padding: 16px;
    .product_wrap {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      .title {
        text-align: center;
        font-size: 20px;
        color: #333333;
        font-weight: 500;
        margin-bottom: 20px;
      }
      .product_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        .product {
          width: 48%;
          height: auto;
          background: #ffffff;
          border-radius: 24px;
          margin-top: 20px;
          position: relative;
          .img-wrap {
            position: relative;
            width: 100%;
            img {
              width: 100%;
              height: auto;
              left: 0;
              top: 0;
              transform: none;
              position: static;
              &:nth-child(2) {
                position: absolute;
              }
            }
          }
          > span {
            position: absolute;
            bottom: 0;
            left: 0;
            top: 0;
            right: 0;
            background: linear-gradient(180deg, rgba(198, 198, 198, 0) 0%, #333333 100%);
            color: white;
            display: flex;
            align-items: flex-end;
            padding: 12px;
            border-radius: 12px;
          }
        }
      }
    }
  }
}
</style>
